var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sm:-mx-6 yacht-itinerary-list"},_vm._l((_vm.itineraries),function(itinerary,index){return _c('li',{key:itinerary.id},[_c('itinerary-item',{staticClass:"mb-16",attrs:{"itinerary":itinerary,"index":index},on:{"enquire-click":_vm.handleEnquireClick}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }